import { Injectable } from '@angular/core';
import { AnswerType } from '../code';

@Injectable({
  providedIn: 'root',
})
export class QuestionCacheService {
  private _cache: AnswerType | undefined;
  public get cache(): AnswerType | undefined {
    return this._cache;
  }
  public set cache(v: AnswerType | undefined) {
    this._cache = v;
  }
}
